<p-scrollPanel #sp [attr.id]="id">
    <ng-content></ng-content>
</p-scrollPanel>
